import { FullScreenPageContainer } from '@/components/utils/FullScreenPageContainer';
import { Link } from 'react-router-dom';
import { linkoutConfigs } from '@/config/routing/LinkoutConfig';
import useRegistrationKitId, { RegisterInterrupts } from '@/hooks/registration/useRegistrationKitId';
import { RegistrationScreen } from '@/components/utils/RegistrationScreen';
import useRegisterStore, {
  RegistrationTrack,
} from '@/hooks/useRegistrationStore';
import useRegistration from '@/hooks/registration/useRegistration';
import * as P from '@/constants/paths';
import { useUserStore } from '@/hooks/useUserStore';

export const RegistrationCancerDetectAndTrialBundle = ({
  interrupt,
}: {
  interrupt: RegisterInterrupts;
}) => {
  const { setRestrictedRegistrationSteps } = useRegisterStore();
  const { navigateWithParams } = useRegistration();
  const { user: userData } = useUserStore();
  const { checkMultiKitValidation, kidIdFromRemote, isKitQueryLoading } = useRegistrationKitId();

  const handleNavigation = () => {
    if (userData) {
      checkMultiKitValidation(kidIdFromRemote);
    } else {
      Promise.all([
        setRestrictedRegistrationSteps([
          RegistrationTrack.ContactInformation,
          RegistrationTrack.PersonalInformation,
          RegistrationTrack.AddressConfirmation,
          RegistrationTrack.RegistrationConfirmation,
          RegistrationTrack.TermsOfService,
          RegistrationTrack.ConsentForm,
        ]),
        navigateWithParams(P.REGISTRATION_ACCOUNT_CREATION),
      ]);
    }
  };
  return interrupt === RegisterInterrupts.CdKit ? (
    <FullScreenPageContainer>
      <h2 className="text-3xl font-sans mb-10 font-medium">
        {'Check Email to Continue'}
      </h2>
      <div className="flex flex-col gap-6">
        <p className="font-sans text-secondary">
          {
            'An email will be sent to the email address you used to purchase Oral Health Pro™ with CancerDetect'
          }
        </p>
        <p className="font-sans text-secondary">
          Didn‘t receive email? Contact Viome{' '}
          <Link
            className="underline underline-offset-4"
            to={linkoutConfigs.faqs}
          >
            Customer Support
          </Link>{' '}
          for help.
        </p>
      </div>
    </FullScreenPageContainer>
  ) : (
    <RegistrationScreen
      title="This test kit is part of a bundle"
      description={
        'The made-for-you products in your bundle will ship after your test results are released.'
      }
      hideBackButton
      primaryActionLabel="I Acknowledge"
      isLoading={isKitQueryLoading}
      primaryActionOnClick={handleNavigation}
    />
  );
};
